import { withHistoryUpdate } from "../../project";
export const setDescription = (snapshot, command, captureChangeUnitOfWorkOptions) => {
    if (captureChangeUnitOfWorkOptions) {
        const { uow, getListeners } = captureChangeUnitOfWorkOptions;
        const change = {
            kind: "baseData",
            payload: {
                description: command.description,
            },
        };
        uow.addChange(change, getListeners({ target: "baseDocument" }));
    }
    return withHistoryUpdate(snapshot, (draft) => {
        draft.description = command.description;
    });
};
export const setName = (snapshot, command, captureChangeUnitOfWorkOptions) => {
    if (captureChangeUnitOfWorkOptions) {
        const { uow, getListeners } = captureChangeUnitOfWorkOptions;
        const change = {
            kind: "baseData",
            payload: {
                name: command.name,
            },
        };
        uow.addChange(change, getListeners({ target: "baseDocument" }));
    }
    return withHistoryUpdate(snapshot, (draft) => {
        draft.name = command.name;
    });
};
export const clearDocument = (snapshot, _command, captureChangeUnitOfWorkOptions) => {
    if (captureChangeUnitOfWorkOptions) {
        const { uow, getListeners } = captureChangeUnitOfWorkOptions;
        const nodesToRemove = Object.keys(snapshot.pcbLayoutNodes || {});
        const change = {
            kind: "subCollection",
            payload: {
                pcbLayoutNodes: {
                    remove: nodesToRemove,
                },
            },
        };
        const listeners = [
            ...getListeners({ target: "pcbNode", uids: nodesToRemove }),
            ...getListeners({ target: "allPcbNodes" }),
        ];
        uow.addChange(change, listeners);
    }
    return withHistoryUpdate(snapshot, (draft) => {
        draft.pcbLayoutNodes = {};
        draft.pcbLayoutRuleSets = {};
    });
};
//# sourceMappingURL=baseDocument.js.map